(()=>{
 if(window.yrCartCoordinator)return;
 window.yrCartCoordinator=true;
 const nativeFetch=window.fetch.bind(window);
 let pending=Promise.resolve();
 window.fetch=function(input,options){
  let url;
  try{url=new URL(input instanceof Request?input.url:String(input),location.href)}catch{return nativeFetch(input,options)}
  if(url.origin!==location.origin)return nativeFetch(input,options);
  const method=String(options?.method||(input instanceof Request?input.method:'GET')).toUpperCase();
  const mutation=method!=='GET'&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/(?:add|change|update|clear)(?:\.js)?\/?$/i.test(url.pathname);
  if(mutation){
   const operation=pending.then(()=>nativeFetch(input,options));
   pending=operation.then(()=>undefined,()=>undefined);
   return operation;
  }
  if(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\.js$/i.test(url.pathname))return pending.then(()=>nativeFetch(input,options));
  return nativeFetch(input,options);
 };
})();
